var map = {
	"./admin": "4piF",
	"./admin.js": "4piF",
	"./app": "aRNo",
	"./app.js": "aRNo",
	"./index": "YaEn",
	"./index.js": "YaEn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "P/1i";


//////////////////
// WEBPACK FOOTER
// ./src/router ^\.\/.*$
// module id = P/1i
// module chunks = 10